import { createApp } from 'vue'
import App from './App.vue'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import './style.css'
import router from './router'
import store from './store'

const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App)

app
  .use(vuetify)
  .use(router)
  .use(store)
  .mount('#app')

